<template functional>
    <div
        :class="{
            'loading-wrapper': true,
            'loading-wrapper--is-loading': props.loading,
            [`loading-wrapper--${props.bgColor}`]: props.bgColor,
        }"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LoadingWrapper',
    props: {
        /**
         * Whether or not it's loading
         */
        loading: {
            type: Boolean,
            default: false,
        },
        /**
         * Background color with opacity. Available colors: `grey-50`. Default: `white`
         */
        bgColor: {
            type: String,
            default: '',
        },
    },
};
</script>
